import {
  type EntryDataField,
  type FormatSchema,
  type SchemaSettings,
  TournamentFormat,
} from "./TournamentFormat";
import { type TournamentState, blankTournamentState } from "./types";

const schema = {} satisfies FormatSchema;

/**
 * Custom tournament format implementation
 * Allows complete manual control over match creation, entry assignment, and winner progression
 */
export class CustomFormat extends TournamentFormat<typeof schema> {
  getName(): string {
    return "Custom";
  }

  get description(): string {
    return "Manual tournament management - create and manage matches yourself";
  }

  getEntryLimits(): { min: number; max: number } {
    return {
      min: 2,
      max: 1000, // Very high limit for flexibility
    };
  }

  getSettingsSchema() {
    return schema;
  }

  getEntryDataSchema(): EntryDataField[] {
    return [];
  }

  getMatchDataSchema(): EntryDataField[] {
    return [];
  }

  transform(state?: TournamentState, _settings?: SchemaSettings<typeof schema>): TournamentState {
    // If no state provided, return empty state
    if (!state) {
      const blankState = blankTournamentState();
      blankState.metadata = {
        transformCount: 0,
        lastTransformed: new Date().toISOString(),
        formatVersion: "1.0.0",
      };
      return blankState;
    }

    // Update metadata to track transformations
    const metadata = state.metadata || {};
    metadata.transformCount = (metadata.transformCount || 0) + 1;
    metadata.lastTransformed = new Date().toISOString();
    metadata.formatVersion = "1.0.0";

    // For Custom format, we preserve the existing state exactly as it is
    // No auto-generation of matches, no auto-propagation of winners
    return {
      ...state,
      metadata,
    };
  }
}
